module.exports = __webpack_public_path__ + "media/images/page/congratulation-tx2-6dd63fa106e7747f9a7cd8fc27367af1.png";